import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { StateProvider, initialState, reducer } from "./services/state";

import "./index.css";
import App from "./App";

import * as serviceWorker from "./serviceWorker";

const theme = createTheme({
  palette: {
    mode: "light", // was 'type'
    primary: {
      main: "#ababab",
      contrastText: "#fff",
    },
    secondary: {
      main: "#14a99d",
      contrastText: "#fff",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: "white",
        },
        containedSecondary: {
          color: "white",
        },
      },
    },
  },
});

ReactDOM.render(
  <BrowserRouter>
    <StateProvider initialState={initialState} reducer={reducer}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StateProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
